export enum WeeksErrorType {
  NoTimeZoneDefined,
  Unauthorized,
  Unspecified,
}
